module.exports = __webpack_public_path__ + "img/c1_m.2057dde9.png";